import { useQuery } from 'react-query';
import { useAuthorizedClient } from '@contexts/Auth';
import { useMerchantId } from '@hooks/useMerchantId';

function useEarnings({
  limit = 6,
  cursor,
  tabStatus = 'closed',
}: {
  limit?: number;
  cursor?: string;
  tabStatus?: 'open' | 'closed';
}) {
  const client = useAuthorizedClient();
  const merchantId = useMerchantId();

  const params = new URLSearchParams({
    merchant_id: merchantId,
    tab_status: tabStatus,
    ...(limit && { limit: String(limit) }),
    ...(cursor && { cursor: String(cursor) }),
    order_by: '-purchase_date',
  });

  return useQuery(
    ['earnings', { limit, cursor }],
    () => client(`/v1/purchases?${params}`, {}).then(data => data),
    { enabled: !!merchantId }
  );
}

export { useEarnings };
